export class HostData {
    
    constructor(public secretkey?: string,
        public domain?: string,
        public sendtoaddr?: string,
        public sendfromaddr?: string) { }
    }



// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/classes/host-data.class.ts